import { Chip, FormControl, InputLabel, OutlinedInput, Select } from "@mui/material";
import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';

/**
 * 
 * @param {object} props 
 * @param {string} props.label
 * @param {string} props.size
 * @param {string} props.value
 * @param {Function} props.onChange
 * @param {boolean} props.fullWidth
 */
export default class MultiSelect extends Component {

   labelId = 'lbl-' + uuid();

   handleChange = e => {
      let value = e.target.value;
      if (typeof value === 'string') // in case it's auto-fill
         value = value.split(',');
      this.props.onChange(value);
   }

   render() {
      const { label, size, value, children, fullWidth } = this.props;

      return (
         <FormControl>
            <InputLabel htmlFor={this.labelId}>{label}</InputLabel>
            <Select
               id={this.props.id}
               labelId={this.labelId}
               multiple
               label={label}
               value={value}
               onChange={this.handleChange}
               input={<OutlinedInput size={size} label={label} />}
               fullWidth={fullWidth}
               renderValue={(selected) => (
                  <div className="flex flex-wrap gap-1" sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                     {
                        selected.map(value => (
                           <Chip key={value} label={value} />
                        ))
                     }
                  </div>
               )}
            >
               {children}
            </Select>
         </FormControl>
      );
   }
}